import { render, staticRenderFns } from "./UploadForm.vue?vue&type=template&id=3df080de&scoped=true&"
import script from "./UploadForm.vue?vue&type=script&lang=ts&"
export * from "./UploadForm.vue?vue&type=script&lang=ts&"
import style0 from "./UploadForm.vue?vue&type=style&index=0&id=3df080de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df080de",
  null
  
)

export default component.exports